/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

import { setLauncherVisible } from 'app/utility/Intercom.js';

class IntercomWidgetControl extends React.Component {
    componentDidMount() {
        setLauncherVisible(this.props.displayHelp);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.displayHelp !== this.props.displayHelp) {
            setLauncherVisible(this.props.displayHelp);
        }
    }

    render() {
        return null;
    }
}

IntercomWidgetControl.displayName = 'IntercomWidgetControl';

IntercomWidgetControl.propTypes = {
    displayHelp: PropTypes.bool
};

IntercomWidgetControl.defaultProps = {
    displayHelp: true
};

export default IntercomWidgetControl;
